import React, { useCallback, useEffect, useMemo, useState } from "react";
//libs
import { useNavigate, useLocation } from "react-router-dom";
import Parse from "html-react-parser";
//redux
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/ducks";
//components
import { PortalOrderDropdown } from "pages/Quotes/components/Dropdown/PortalOrderDropdown";
import { BudgetDropdown } from "pages/Quotes/components/Dropdown/BudgetDropdown";
import IndicatorFilterModal from "./IndicatorFilter/IndicatorFilterModal";
import { IsNullOrEmpty } from "utils/StringNullOrEmpty";
import { TablePortal } from "components/TablePortal";
import { Column } from "components/Layout/Grid";
import toast from "components/Toast/dispatch";
import { Button } from "components/Button";
import Modal from "components/Modal";
//interfaces
import {
  statusLockedButton,
  statusProcessing,
  statusSent,
  supplierStatusLockedButton,
  supplierStatusSent,
} from "components/TablePortal/interface";
import {
  supplierStatusValues,
  UserNamePrioritization,
} from "components/Table/interface";
import { IQuotes, ViewListQuoteProps } from "models/Quote";
import { GridQuotesProps } from "./interface";
import { StateType } from "../interface";
//utils
import {
  dashboardOrderModel,
  dashboardQuoteModel,
  newDashboardQuoteModel,
} from "./utils";
import { toastNonstandardCode, toastNotPermissionUnlock } from "../utils";
import { toastUnlock, toastUnlockAfterRA } from "pages/Quotes/utils/Quotes";
import { DateOutputStr } from "utils/DateOutput";
//services
import DomainSettingService from "services/domainSetting.service";
import QuoteServices from "services/quote.service";
//context
import { useDetailsQuoteContext } from "contexts/DetailsQuote";
//assets
import quoteUnlocked from "img/quote-unlocked.svg";
import quoteBlocked from "img/quote-blocked.svg";
import ErrorIcon from "img/error-img.svg";

export const GridQuotes: React.FC<GridQuotesProps> = (props) => {
  const {
    quote,
    tableOrder,
    currentPage,
    refreshItem,
    getPreOrder,
    pageSizeGrid,
    setTableOrder,
    setCurrentPage,
    getBionexoQuote,
    orderRadioSelected,
  } = props;

  const blockedSimultaneousAccess = process.env.REACT_APP_BLOCKED_SIMULTANEOUS_ACCESS;
  const bcgOnly = process.env.REACT_APP_BCG_ONLY === 'true';

  const [isModalVisible, setIsModalVisible] = useState(false);

  const user = useSelector((stateUser: RootState) => stateUser.user);
  const quoteItemStorage = useSelector(
    (stateStorage: RootState) => stateStorage.quoteItem
  ) ?? { id: "" };
  const conditionalStatusSent = (status: string, supplierStatus: string) => {
    return (
      statusSent.includes(status) && supplierStatusSent.includes(supplierStatus)
    );
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location: StateType = useLocation();
  const { order } = useDetailsQuoteContext();

  const [usersAllowUnlockAnyQuote, setUsersAllowUnlockAnyQuote] = useState<string[]>([]);

  const _quotesServices = new QuoteServices();
  const _domainSettingService = new DomainSettingService();

  const getUsersAllowUnlockAnyQuote = async () => {
    const response = await _domainSettingService.get(
      undefined,
      undefined,
      undefined,
      {
        and: [
          { identifier: { eq: "UsersAllowUnlockingAnyQuote" } },
          { enabled: { eq: true } },
        ],
      }
    );

    const { data } = response;
    const allowedEmails = data[0].value.split(",");
    setUsersAllowUnlockAnyQuote(allowedEmails);
  };

  const configureClickTable = (quoteCheck: IQuotes) => {
    if (conditionalStatusSent(quoteCheck.status, quoteCheck.supplierStatus)) {
      if (supplierStatusValues.includes(quoteCheck.supplierStatus)) {
        return navigate(`/gravado-no-money/${quoteCheck.id}`, {
          state: { dashboard: true },
        });
      }

      return toast.info(
        "Atenção",
        "Não é possível editar a cotação escolhida."
      );
    }
  };

  const checkQuoteStillBlocked = (idQuote: string, usersQuotes?: string[]) => {
    if (!usersQuotes) {
      refreshItem("viewList.status", false, idQuote);

      return true;
    }

    toastNotPermissionUnlock();
  };

  const checkPermission = async (
    itemQuote: IQuotes,
    nameUser: string,
    userLogged?: string ) => {
    try{
      const response = await _quotesServices.checkQuotationViewed(itemQuote.id);
      const users: string[] = response.data.data.user;
      const canBeUnBlocked = response.data.data.canBeUnBlocked;

      const allowedUnlock = usersAllowUnlockAnyQuote.includes(userLogged!);
      
      const toastSelected = allowedUnlock
        ? toastUnlock(itemQuote, dispatch, undefined, getBionexoQuote)
        : (canBeUnBlocked 
          ? toastUnlockAfterRA(itemQuote, dispatch, undefined, getBionexoQuote) 
          : toastUnlock(itemQuote, dispatch, undefined, getBionexoQuote));

      const shouldToast = (nameUser === userLogged || allowedUnlock || canBeUnBlocked) && nameUser !== UserNamePrioritization;
      if(shouldToast){toastSelected}
      else{checkQuoteStillBlocked(itemQuote.id, users);}
    }
    catch(error){
      console.error("Erro ao verificar permissão:", error);
    }
  };

  const checkUserAccessQuote = (listUsers?: ViewListQuoteProps[]) => {
    return listUsers ? listUsers.filter((x) => x.status === true) : [];
  };

  const renderButton = (quoteItem: IQuotes) => {
    const item: ViewListQuoteProps[] = checkUserAccessQuote(quoteItem.viewList);
    const lastAccess =
      quoteItem.viewList && item.length > 0 ? item[0].name : "";
    const userNameLastAccess =
      quoteItem.viewList && item.length > 0 ? item[0].userName : "";
      const lastDateAccess =
      quoteItem.viewList && item.length > 0 && item[item.length - 1].history.length > 0
        ? item[item.length - 1].history[item[item.length - 1].history.length - 1].blockedIn
        : "";
    const viewTooltip = `
      <p class='text-styles text-center'>
        Usuário acessando:
        <b class='color-blue-gray fs-2'>${lastAccess}</b>
      </p>
      <p class='text-styles text-center'>
        Hora do bloqueio:
        <b class='color-blue-gray fs-2'>
          ${DateOutputStr(lastDateAccess, `dd/MM/yyyy 'às' HH:mm`)}
        </b>
      </p>
    `;
    
    const isDisconsidered = quoteItem.supplierStatus === "DISREGARDED";
    if (isDisconsidered) return <></>;

    return (
      <Button
        html
        width="26px"
        onClick={() =>
          blockedSimultaneousAccess && item.length > 0 && quoteItemStorage
            ? checkPermission(quoteItem, userNameLastAccess, user?.email)
            : {}
        }
        tooltip={blockedSimultaneousAccess && item.length > 0 && quoteItemStorage ? viewTooltip : ""}
      >
        <img
          src={blockedSimultaneousAccess && item.length > 0 && quoteItemStorage ? quoteBlocked : quoteUnlocked}
          alt="bloquear/desbloquear cotação"
          className="img-block-quote"
        />
      </Button>
    );
  };

  const statusQuoteViewed = async (data: IQuotes, read?: boolean) => {
    if (read) return true;

    const response = await _quotesServices.checkQuotationViewed(data.id);

    const users: string[] = response.data.data.user;

    if (
      blockedSimultaneousAccess &&
      users &&
      !users.includes(user?.fullName ?? "") &&
      quoteItemStorage
    ) {
      const description = Parse(
        `<p class='text-styles color-blue-gray mt-3 text-wrap text-center description-quote-blocked'>Essa cotação esta sendo manipulada pelo colaborador <b>${users[0]}</b>. Aguarde a finalização para acessar as informações.</p>`
      );

      toast.errorCustom(
        "Importante!",
        description,
        ErrorIcon,
        true,
        "Fechar",
        19,
        14,
        true,
        getBionexoQuote
      );

      return false;
    }

    if (statusSent.includes(data.status) && supplierStatusSent.includes(data.supplierStatus) ) {
      navigate(`/gravado-no-money/${data.id}`, { state: { dashboard: true } });
    } else {
      navigate(`/cotacoes-nova/${data.id}`, { state: { ...data } });
    }
    return true;
  };

  const saveQuotationViewed = useCallback(
    async (
      dataQuote: IQuotes,
      quotationViewed: boolean,
      readQuote?: boolean,
      isRead?: boolean
    ) => {
      if (dataQuote.code.length > 9) {
        toastNonstandardCode(dataQuote.origin);
      } else {
        if (dataQuote.company?.crmCustomerCode) {
          const isDisconsidered = dataQuote.supplierStatus === "DISREGARDED";

          const verifyStatusQuotation =
            (statusLockedButton.includes(dataQuote.status) &&
              supplierStatusLockedButton.includes(dataQuote.supplierStatus)) ||
            (statusSent.includes(dataQuote.status) &&
              supplierStatusSent.includes(dataQuote.supplierStatus));

          if (isDisconsidered && (bcgOnly || user?.isBCGUser)) {
            toast.info("Cotação desconsiderada", "A cotação foi desconsiderada por condições comerciais.");
            return;
          }

          if (statusProcessing.includes(dataQuote.status)) {
            return;
          }

          if (verifyStatusQuotation) {
            const statusQuote: boolean = await statusQuoteViewed(
              dataQuote,
              readQuote
            );

            if (statusQuote) {
              window.sessionStorage.setItem(
                location.pathname + " DashboardWindowScrollY: ",
                window.scrollY.toString()
              );
              window.sessionStorage.setItem(
                location.pathname + " DashboardWindowScrollX: ",
                window.scrollX.toString()
              );

              if (readQuote) {
                const response = await _quotesServices.quotationViewedIsRead(
                  dataQuote.id,
                  isRead
                );
                if (response) {
                  const newData = { ...dataQuote };
                  newData.viewList = [
                    {
                      name: user?.username!,
                      userName: user?.email!,
                      status: false,
                      updatedDate: new Date().toDateString(),
                      history: [{
                        blockedIn: new Date().toDateString(),
                      },],
                    },
                  ];

                  refreshItem("isRead", isRead, dataQuote.id);
                  refreshItem("viewList", newData.viewList, dataQuote.id);

                  renderButton(newData);
                }
              } else {
                const response = await _quotesServices.quotationViewed(
                  dataQuote.id,
                  quotationViewed
                );
                if (response)
                  refreshItem("quotationViewed", quotationViewed, dataQuote.id);
              }
            }
          } else {
            configureClickTable(dataQuote);
          }
        } else {
          toast.info(
            "Cliente não cadastrado",
            "Para continuar com a cotação, é necessário cadastrar o cliente antes."
          );
        }
      }
    },
    [quote?.data]
  );

  const openModal = () => {
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    getUsersAllowUnlockAnyQuote();
  }, []);
  
  const useNewDashboardModel = bcgOnly || !IsNullOrEmpty(user?.buBCG);
  const defaultDashboardModel = dashboardQuoteModel(renderButton, saveQuotationViewed, getBionexoQuote, openModal);
  const bcgDashboardModel = newDashboardQuoteModel(renderButton, saveQuotationViewed, openModal, getBionexoQuote);
  const selectedDashboardModel = useNewDashboardModel ? bcgDashboardModel : defaultDashboardModel;

  const modelViewed = orderRadioSelected ? dashboardOrderModel() : selectedDashboardModel;

  const MemoGridQuotes = useMemo(
    () => (
      <TablePortal
        model={modelViewed}
        tableOrder={tableOrder}
        pageSize={pageSizeGrid}
        currentPage={currentPage}
        renderButton={renderButton}
        setTableOrder={setTableOrder}
        onPageChange={setCurrentPage}
        className="w-md-100 quote-grid"
        orderRadioSelected={orderRadioSelected}
        data={orderRadioSelected ? order?.data : quote?.data}
        error={orderRadioSelected ? order?.error : quote?.error}
        onReload={orderRadioSelected ? getPreOrder : getBionexoQuote}
        totalPages={orderRadioSelected ? order?.totalPages : quote?.totalPages}
        DropdownTemplate={{ Order: PortalOrderDropdown, Quote: BudgetDropdown }}
      />
    ),
    [quote, order, user, orderRadioSelected]
  );

  return (
    <>
      <Column className="w-100 quote-grid">{MemoGridQuotes}</Column>

      {isModalVisible && (
        <Modal
          width="384px"
          height="auto"
          borderRadius={3}
          title=""
          minWidth={""}
          onCloseAction={closeModal}
          showCloseButton={false}
        >
          <IndicatorFilterModal handleCloseModal={closeModal} />
        </Modal>
      )}
    </>
  );
};
